// extracted by mini-css-extract-plugin
module.exports = {"selectIcon":"InputContainer_selectIcon__3hIc7"};